module.exports = __webpack_public_path__ + "img/logo_165x60.dc7f4fdb.png";